import styled, { css } from 'styled-components'
import { withDropdownArrow } from 'components/Button/StyledButton'

/* cells */
const cellStyles = `
	display: flex;
	align-items: center;
	padding: 7px 8px;
	overflow: hidden;
	font-size: 14px;
	position: relative;
	font-weight: 300;
	:not(:first-of-type):after {
		content: "";
		position: absolute;
		top: 8px;
		bottom: 8px;
		left: 0;
		width: 1px;
		background: hsla(0,0%,76.5%,.42);
	}
	input {
		width: 100%;
		border: none;
		background: transparent;
	}
	.first-cell {
		&:after {
			content: "";
			position: absolute;
			top: 8px;
			bottom: 8px;
			left: 0;
			width: 4px;
			background: hsla(0,0%,76.5%,.42);
		}
	}
`
const rowStyles = `
	display: flex;
	position: relative;
	&:hover {
		.btn-edit, .btn-del {
			visibility: visible
		}
	}
`
const withSelectRowStyles = `
	padding: 7px 8px 7px 16px;
	&:after {
		content: "";
		position: absolute;
		height: calc(100% - 1px);
		left: 0;
		width: 8px;
		background: hsla(0,0%,76.5%,.42);
	}
`
const selectedRowStyles = `
	.cell {
		font-weight: 400;
	}
	.first-cell{
		&:after {
			background: #3e4c57;
		}
	}
	.cell-del {
		.btn-del {
			visibility: visible;
		}
	}
`

export const StyledRow = styled.div`${({ isSelected, withSelectRow, row, theme }) => `
	${rowStyles}
	${row?.original?.isCancelled ? `
		background: ${theme.errorColor};
	` : ''}
	${withSelectRow ? `
		cursor: pointer;
		.first-cell {
			${withSelectRowStyles}
		}
	` : ''}
	${isSelected ? `
		${selectedRowStyles}
	` : ''}
`}`

// Vanya's implementation
export const StyledCell1 = styled.div`${({ style = {} }) => css`
	${({ isSelectable, isSelected, isFirstCellInRow, theme }) => isFirstCellInRow && isSelectable && css`
		:before {
		height: 100%;
	    background-color: ${isSelected ? theme.primaryColor : '#cdcdcd'};
	    width: 8px;
	    content: "";
	    position: absolute;
	    top: 0;
	    left: 0;
	    left: 0;
		}
		padding-left: 16px !important;
	`}
	cursor: ${({ isSelectable }) => isSelectable ? 'pointer' : 'unset'};
`}`

// Kostya's implementation
export const StyledCell = styled.div`${({ style = {}, className, rowIndex }) => `
	${cellStyles}
	${rowIndex % 2 ? 'background: white;' : ''}
	${style.left === 0 ? `
		:after {
			display: none;
		}
	` : ''}
	${className.includes('cell-del') ? `
		:after {
			display: none;
		}
		.btn-edit {
			visibility: hidden;
			width: 17px;
			height: 17px;
			margin-right: 10px;
			cursor: pointer;
		}
		.btn-del {
			visibility: hidden;
			font-size: 17px;
			cursor: pointer;
		}
		.add-icon {
			display: block;
			cursor: pointer;
			position: absolute;
			top: 50%;
			transform: translate(0, -50%);
			right: 10px;
			z-index: 1;
		}
	` : ''}
`}`

export const FooterCell = styled.div`
	position: relative;
	${({ noSeparator }) => noSeparator && `
		:after {
			display: none;
		}
	`}
	${cellStyles}
`
export const StyledHeaderCell = styled(FooterCell)`
	width: 100px;
	background-color: ${props => props.theme.primaryColor};
	cursor: ${props => props.canSort ? 'pointer' : 'unset'};
	${props => props.isSorted && `
		box-shadow: inset 0 ${props.isSortedDesc ? '-2px' : '2px'} 0 0 #f9cb37;
	`}
	${props => props.className === 'cell-del' ? `
		:after {
			display: none;
		}` : ''}
	font-size: 12px;
	:first-of-type {
		border-radius: 3px 0 0 3px;
	}
	:last-of-type {
		border-radius: 0 3px 3px 0;
	}
	:not(:first-of-type):after {
		background: rgba(47,54,72,.8);
	}
	/* :nth-last-child(1):after {
		display: none;
	} */
`
/**/

export const StyledExpander = withDropdownArrow(styled.div`
	display: inline;
	margin: 0px 20px 0 5px;
	padding: 0 !important;
`)

export const StyledTable = styled.div`
	white-space: nowrap;
	text-overflow: ellipsis;
	border: none;
	box-shadow: 0 2px 2px 0 rgba(90,90,90,.2);
	.cell-del {
		justify-content: flex-end;
	}	
	&>div {
		overflow: hidden;
		&::-webkit-scrollbar { display: none; }
		-ms-overflow-style: none;
	}
`
export const StyledTableHead = styled.div`
	position: sticky !important;
	z-index: 2;
	top: 0;
	left: 0;
	div input {
		background-color: #efefef !important;
	}
	.cell-del {
		justify-content: flex-end;
		.addIcon {
			position: static;
			transform: none;
		}
	}
`
export const StyledTableBody = styled.div`
	height: 100%;
	position: relative;
`
export const StyledHeaderRow = styled.div`
	display: flex;
	height: 36px;
	min-height: 36px;
	font-weight: 300;
	font-size: 12px;
	color: #fff;
	background-color: ${props => props.theme.primaryColor};
`
export const StyledFooterRow = styled(StyledHeaderRow)`
	background-color: ${props => props.theme.greenColor};
`

export const StyledFooter = styled(StyledTableHead)`
	background-color: ${props => props.theme.greenColor};
	display: flex;
	bottom: 0;
`

export const StyledContainerHeader = styled.div`
	display: flex;
	p {
		font-size: 16px;
		margin-right: auto;
	}
	svg {
		cursor: pointer;
	}
	.btn-dropdown {
		background: #fff;
		margin-bottom: 4px;
	}
`

export const NoData = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1em 0.7em;
	background: #efefef;
	color: #afafaf;
	width: 100%;
	height: calc(100% - 36px);
	transform: unset;
`
